export enum LoadingSpinnerEnum {
  BLUE_ROYAL_COLOR = 'spinnerBlueRoyalColor',
  WHITE_COLOR = 'spinnerWhiteColor',
}
